@if (cancer !== null && locService.localisations.length) {
  <div>
    <div class="row">
      <!--First col already visible-->
      <div class="col" id="__GRID__COL__1">
        <fieldset>
          <mat-select class="form-control"
            [compareWith]="compareByIri"
            [(ngModel)]="localisationSelected[0]"
            placeholder="{{ 'general.selectionner' | translate }}..."
            (ngModelChange)="updateSelect($event, 0)"
            panelClass="full-option-size"
            required>
            <mat-option  [value]="null">{{ 'general.selectionner' | translate }}...</mat-option>
            @for (loc of locService.localisations; track loc) {
              <mat-option [value]="loc">
                {{translationService.getTranslation(loc)?.label}}
              </mat-option>
            }
          </mat-select>
          @if (localisationSelected[0] === null || localisationSelected[0]  === '') {
            <span class="invalid-feedback display-block">{{ 'general.champObligatoire' | translate }}</span>
          }
        </fieldset>
      </div>
      <!--Second col, visible if col 1 has children-->
      @if (localisationSelected[0] !== null && getLocalisationChoices(localisationSelected[0]['children']).length) {
        <div id="__GRID__COL__2" class="col">
          <fieldset>
            <mat-select
              class="form-control"
              [compareWith]="compareByIri"
              [(ngModel)]="localisationSelected[1]"
              (ngModelChange)="updateSelect($event, 1)"
              placeholder="{{ 'general.selectionner' | translate }}..."
              [required]="localisationSelected[3]"
              panelClass="full-option-size"
              >
              <mat-option [value]="null">{{ 'general.selectionner' | translate }}...</mat-option>
              @for (loc of getLocalisationChoices(localisationSelected[0]['children']); track loc) {
                <mat-option [value]="loc">
                  {{translationService.getTranslation(loc)?.label}}
                </mat-option>
              }
            </mat-select>
            @if ((localisationSelected[1] === null || localisationSelected[1]  === '') && localisationSelected[3]) {
              <span class="invalid-feedback display-block">{{ 'general.champObligatoire' | translate }}</span>
            }
          </fieldset>
        </div>
      }
      <!--Third col if col second has children-->
      @if (localisationSelected[0] !== null && localisationSelected[0]['children'] !== null && localisationSelected[1] !== null && localisationSelected[1]['children'] !== null && getLocalisationChoices(localisationSelected[1]['children']).length) {
        <div id="__GRID__COL__3" class="col">
          <fieldset>
            <mat-select
              class="form-control" panelClass="full-option-size"
              [compareWith]="compareByIri"
              [(ngModel)]="localisationSelected[2]"
              (ngModelChange)="updateSelect($event, 2)"
              placeholder="{{ 'general.selectionner' | translate }}..."
              required>
              <mat-option [value]="null">{{'general.selectionner'|translate}}</mat-option>
              @for (loc of getLocalisationChoices(localisationSelected[1]['children']); track loc) {
                <mat-option [value]="loc">
                  {{translationService.getTranslation(loc)?.label}}
                </mat-option>
              }
            </mat-select>
          </fieldset>
          @if (localisationSelected[2] === null || localisationSelected[2]  === '') {
            <span class="invalid-feedback display-block">{{ 'general.champObligatoire' | translate }}</span>
          }
        </div>
      }
      <!--Custom Col visible if last selected col is champSaisieLibre = true-->
      @if (displayCustomValue()) {
        <div id="__GRID__COL__CUSTOM" class="col">
          <input type="text" required class="form-control" placeholder="Précision..." [(ngModel)]="customValue" (ngModelChange)="updateCancerCourant('customValue')">
          @if (!customValue.length || customValue === null) {
            <span class="invalid-feedback display-block">{{'general.champObligatoire'|translate}}</span>
          }
        </div>
      }
      <!--Last col-->
      <div class="col last-col"  id="__GRID__COL__4">
        <mat-select  style="width: 153px" class="form-control" [(ngModel)]="localisationSelected[3]" panelClass="full-option-size"
          (ngModelChange)="changeCancerType($event); updateCancerCourant('cancerType')">
          <mat-option [value]="false">{{'front.field.localisation.primitifLocalise'|translate}}</mat-option>
          <mat-option [value]="true">{{'front.field.localisation.primitifMetastase'|translate}}</mat-option>
        </mat-select>
        <a class="round" color="warn" style="font-size: 10px;" (click)="removeCancer()">
          {{ 'general.supprimer' | translate }}
        </a>
      </div>
    </div>
    @if (localisationSelected[3] === true) {
      <div>
        <div class="row mt-1" style="position: relative">
          <div class="col">
            <div class="liste-localisations">
              <ul>
                @for (meta of locService.metastases; track meta) {
                  <li>
                    <mat-checkbox [(ngModel)]="selected['ID__'+meta.id]" (ngModelChange)="selectLoc(meta, $event)">
                      {{translationService.getTranslation(meta)?.label}}
                    </mat-checkbox>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
<div class="sepa"></div>
